import { INVOICE_TYPE } from "../constants/invoiceTypes";

// Proformas share the invoice table with real invoices and are only
// distinguished by `typeId` (1 = Invoice, 2 = Proforma). On sales and
// sale-history tables we label proformas "PF<proforma number>" so they
// are visually distinct at a glance; invoices keep their existing
// company-coded reference untouched.
const formatInvoiceReference = invoice => {
  if (invoice?.typeId === INVOICE_TYPE.PROFORMA) {
    return `PF${invoice?.proforma ?? ""}`;
  }
  return invoice?.reference ?? "";
};

export { formatInvoiceReference };
